import { MY_ACCOUNT_VIEW_QUERY_PARAM } from '../myAccountPlugin';

export const myAccountNativeDeepLinksPlugin = {
  postBootstrap({ params }) {
    const myAccountView = new URLSearchParams(window.location.search).get(MY_ACCOUNT_VIEW_QUERY_PARAM);
    if (!myAccountView) {
      return;
    }
    const standaloneUrl = params.mapping[myAccountView];
    if (!standaloneUrl) {
      return;
    }

    window.location.href = `whsbkh://?action=openURLWithLogin&url=${encodeURIComponent(standaloneUrl)}`;
  },
};
